var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "fu-table",
        { attrs: { data: _vm.tableData } },
        [
          _c("el-table-column", { attrs: { type: "selection" } }),
          _c("el-table-column", {
            attrs: { prop: "name", label: "姓名", "min-width": "180", fix: "" }
          }),
          _c("el-table-column", {
            attrs: { prop: "enable", label: "语言(可行内编辑)" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "fu-select-rw-switch",
                      {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "read",
                              fn: function() {
                                return [
                                  row.language === "zh-CN"
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            "disable-transitions": "",
                                            type: "danger"
                                          }
                                        },
                                        [_vm._v("中文")]
                                      )
                                    : _c(
                                        "el-tag",
                                        {
                                          attrs: { "disable-transitions": "" }
                                        },
                                        [_vm._v("English")]
                                      )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: row.language,
                          callback: function($$v) {
                            _vm.$set(row, "language", $$v)
                          },
                          expression: "row.language"
                        }
                      },
                      [
                        _c("el-option", {
                          key: "zh-CN",
                          attrs: { label: "中文", value: "zh-CN" }
                        }),
                        _c("el-option", {
                          key: "en-US",
                          attrs: { label: "English", value: "en-US" }
                        })
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "address", label: "地址(可行内编辑)" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("fu-input-rw-switch", {
                      model: {
                        value: row.address,
                        callback: function($$v) {
                          _vm.$set(row, "address", $$v)
                        },
                        expression: "row.address"
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "date", label: "日期", "min-width": "180" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }